// Home = kid list + per-kit history library (issue #11). Optional-first: with
// no kids yet, the CTA card leads into kid creation instead of a forced flow.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { createKid, watchKids, watchKitsForKid } from "../api";
import type { Kit, Kid } from "../types";

export default function Home() {
  const [kids, setKids] = useState<Kid[]>([]);
  const [kits, setKits] = useState<Kit[]>([]);
  const [name, setName] = useState("");
  const [grade, setGrade] = useState("1");
  const [adding, setAdding] = useState(false);

  const [selKid, setSelKid] = useState<string>("");
  const [justPaid, setJustPaid] = useState(() => new URLSearchParams(window.location.search).get("checkout") === "success");
  useEffect(() => watchKids(setKids), []);
  useEffect(() => {
    if (kids.length === 0) { setKits([]); return; }
    const kid = kids.find((k) => k.id === selKid) ?? kids[0];
    return watchKitsForKid(kid.id, setKits);
  }, [kids, selKid]);

  return (
    <>
      <h1>Kids</h1>
      {justPaid && (
        <div className="card ok" role="status">
          Payment received — your plan unlocks as soon as Stripe confirms (a few seconds).{" "}
          <button className="linklike" onClick={() => setJustPaid(false)}>dismiss</button>
        </div>
      )}
      {kids.length === 0 && !adding && (
        <div className="card">
          <p>No kids yet — add one to start building weekly kits.</p>
          <button onClick={() => setAdding(true)}>Add a kid</button>
        </div>
      )}
      {/* #31: always-visible affordance — the empty-state-only button locked
          accounts to one kid. Switcher shows from kid #1 so multi-child
          households can actually swap. */}
      {kids.length > 0 && !adding && (
        <p>
          <button className="ghost" onClick={() => setAdding(true)}>+ Add another kid</button>
        </p>
      )}
      {kids.length >= 1 && (
        <p>Show kits for{" "}
          <select value={selKid || kids[0].id} onChange={(e) => setSelKid(e.target.value)}>
            {kids.map((k) => <option key={k.id} value={k.id}>{k.name}</option>)}
          </select>
        </p>
      )}
      {kids.map((k) => (
        <div className="card" key={k.id}>
          <h2>{k.name} <span className="muted">· grade {k.grade}</span></h2>
          <Link to="/new">New kit for {k.name}</Link>
        </div>
      ))}
      {adding && (
        <form
          className="card"
          onSubmit={async (e) => {
            e.preventDefault();
            await createKid(name, grade);
            setAdding(false); setName("");
          }}
        >
          <label>Name <input required value={name} onChange={(e) => setName(e.target.value)} /></label>{" "}
          <label>Grade
            <select value={grade} onChange={(e) => setGrade(e.target.value)}>
              {["K", "1", "2", "3"].map((g) => <option key={g}>{g}</option>)}
            </select>
          </label>
          <p><button type="submit">Save</button> <button type="button" className="ghost" onClick={() => setAdding(false)}>Cancel</button></p>
        </form>
      )}

      {kids.length > 0 && <h1>Kits for {(kids.find((k) => k.id === selKid) ?? kids[0]).name}</h1>}
      {kits.length === 0 && kids.length > 0 && (
        <p className="muted">No kits yet. <Link to="/new">Create the first one</Link>.</p>
      )}
      <ul className="artifacts">
        {[...kits].sort((a, b) => b.createdAt - a.createdAt).map((k) => (
          <li key={k.id}>
            <Link to={`/kit/${k.id}`}>{k.regen ? `↻ ${k.regen.kinds.map((kd) => kd === "wordsearch" ? "word search" : kd).join(", ")} · ` : ""}{k.title} <span className="muted">{k.week}</span></Link>
            <span className={`status-pill status-${k.status}`}>{k.status}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
